import { createTheme, Theme } from '@mui/material';
import {
    TankUtilityBlue,
    GeneracOrange,
    GeneracRed,
    GeneracCharcoal,
} from 'lib/constants';

import generacLogoInverseColors from 'assets/generac-logo-inverse-colors-medium.png';
import generacFuelTrackerLogo from 'assets/generac-fuel-tracker-logo.png';
import { ImgHTMLAttributes } from 'react';

declare module '@mui/material/styles' {
    interface Theme {
        MainMenuBarIndicator: {
            backgroundColor: string;
        };
        AdminSectionDivider: {
            borderColor: string;
        };
    }
    interface ThemeOptions {
        MainMenuBarIndicator?: {
            backgroundColor?: string;
        };
        AdminSectionDivider?: {
            borderColor?: string;
        };
    }
}

export const darkTheme: Theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: GeneracOrange,
        },
        secondary: {
            main: GeneracCharcoal,
        },
        error: {
            main: GeneracRed,
        },
        warning: {
            main: GeneracOrange,
        },
    },
    components: {
        MuiTab: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        color: GeneracOrange, // Selected tab text color
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: GeneracCharcoal, // Black color
                },
            },
        },
    },
    MainMenuBarIndicator: {
        backgroundColor: GeneracOrange,
    },
    AdminSectionDivider: {
        borderColor: GeneracOrange,
    },
});

export const legacyDarkTheme: Theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: TankUtilityBlue,
        },
        secondary: {
            main: TankUtilityBlue,
        },
        error: {
            main: GeneracRed,
        },
        warning: {
            main: GeneracRed,
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: GeneracCharcoal, // Black color
                },
            },
        },
    },
    MainMenuBarIndicator: {
        backgroundColor: 'white',
    },
    AdminSectionDivider: {
        borderColor: 'white',
    },
});

export const legacyLightTheme: Theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: TankUtilityBlue,
        },
        secondary: {
            main: TankUtilityBlue,
        },
        error: {
            main: GeneracRed,
        },
        warning: {
            main: GeneracOrange,
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: GeneracCharcoal, // Black color
                },
            },
        },
    },
    MainMenuBarIndicator: {
        backgroundColor: 'white',
    },
    AdminSectionDivider: {
        borderColor: 'white',
    },
});

/** Generac branding theme. */
export const lightTheme: Theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: GeneracOrange,
        },
        secondary: {
            main: GeneracCharcoal,
        },
        error: {
            main: GeneracRed,
        },
        warning: {
            main: GeneracOrange,
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: GeneracCharcoal, // Black color
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        color: GeneracOrange, // Selected tab text color
                    },
                },
            },
        },
    },
    MainMenuBarIndicator: {
        backgroundColor: GeneracOrange,
    },
    AdminSectionDivider: {
        borderColor: GeneracOrange,
    },
});

interface LogoProps extends ImgHTMLAttributes<HTMLImageElement> {
    islanding?: string;
}

export const Logo = (props: LogoProps) => {
    // const theme = useTheme();
    // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    // const isDarkTheme = theme.palette.mode === 'dark' || prefersDarkMode;

    const logoSrc =
        props.islanding === 'true'
            ? generacFuelTrackerLogo
            : generacLogoInverseColors;

    const logoStyles: any =
        props.islanding === 'true'
            ? { position: 'relative', left: '4px', marginBottom: '30px' }
            : {};
    return (
        <img
            // src={isDarkTheme ? darkLogo : lightLogo}
            src={logoSrc}
            alt="Generac Logo"
            style={logoStyles}
            {...props}
        />
    );
};
